enum ACTIONS {
    CREATE_CANDIDATE = '[CANDIDATE] - CREATE',
    CREATE_CANDIDATE_VALUES = '[CANDIDATE] - CREATE VALUES',
    BACKGROUND_CREATE_CANDIDATE_VALUES = '[CANDIDATE][BACKGROUND] CREATE VALUES',
    
    FETCH_ALL_CANDIDATES = 'FETCH_ALL_CANDIDATES_V2',
    FETCH_CANDIDATE = 'FETCH_CANDIDATE_V2',
    FETCH_CANDIDATE_VALUES = 'FETCH_CANDIDATE_VALUES',
    FETCH_CANDIDATES_VALUES = 'FETCH_CANDIDATES_VALUES',
    FETCH_CANDIDATE_CONCEPT = 'FETCH_CANDIDATE_CONCEPT',
    
    FETCH_CANDIDATE_OVERVIEW_PAGE = '[CANDIDATE] Overview page',

    UPDATE_CANDIDATE = 'UPDATE_CANDIDATE',
    SAVE_CANDIDATE_VALUES = 'SAVE_CANDIDATE_VALUES',
    BACKGROUND_UPDATE_CANDIDATE_VALUES = '[CANDIDATE][BACKGROUND] UPDATE VALUES',
    UPSERT_CANDIDATE_VALUES = '[CANDIDATE] UPSERT VALUES',

    DELETE_CANDIDATE = '[CANDIDATE] - DELETE'
}

export default ACTIONS;

export enum CREATE_CANDIDATE {
    REQUEST = 'CREATE_CANDIDATE_REQUEST',
    SUCCESS = 'CREATE_CANDIDATE_SUCCESS',
    FAILURE = 'CREATE_CANDIDATE_FAILURE'
}

export enum FETCH_ALL_CANDIDATES {
    REQUEST = 'FETCH_ALL_CANDIDATES_REQUEST',
    SUCCESS = 'FETCH_ALL_CANDIDATES_SUCCESS',
    FAILURE = 'FETCH_ALL_CANDIDATES_FAILURE'
}

export enum FETCH_CANDIDATE {
    REQUEST = 'FETCH_CANDIDATE_REQUEST',
    SUCCESS = 'FETCH_CANDIDATE_SUCCESS',
    FAILURE = 'FETCH_CANDIDATE_FAILURE'
}

export enum SAVE_CANDIDATE {
    REQUEST = 'SAVE_CANDIDATE_REQUEST',
    SUCCESS = 'SAVE_CANDIDATE_SUCCESS',
    FAILURE = 'SAVE_CANDIDATE_FAILURE'
}

export enum SAVE_CANDIDATE_STATUS {
    REQUEST = 'SAVE_CANDIDATE_STATUS_REQUEST',
    SUCCESS = 'SAVE_CANDIDATE_STATUS_SUCCESS',
    FAILURE = 'SAVE_CANDIDATE_STATUS_FAILURE'
}

export enum CANDIDATE {
    EDIT = 'CANDIDATE_EDIT',
    RESET = 'CANDIDATE_RESET'
}

export enum FETCH_CANDIDATE_DATASET {
    REQUEST = 'FETCH_CANDIDATE_DATASET_REQUEST',
    SUCCESS = 'FETCH_CANDIDATE_DATASET_SUCCESS',
    FAILURE = 'FETCH_CANDIDATE_DATASET_FAILURE'
}